import { doProcessRules } from '../../lib/processPortalRules'
import { createDebouncedAction } from '../utils'
import * as actionTypes from './actionTypes'

export const processCondRules =
  (path = [], state = null, fullPath = [], rowIndex) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.PROCESS_COND_RULES,
      payload: {
        path,
        fullPath,
        rowIndex,
      },
    })
  }

export const processCondRulesBatch = createDebouncedAction(actionTypes.PROCESS_COND_RULES_BATCH)

export const processCondRulesByChangedPath = (changesPath, params) => (dispatch, getState) => {
  let state = getState()
  state = doProcessRules(
    state,
    Boolean(_.get(window.__FT_APP_STATE__, 'portal')),
    [],
    [],
    changesPath,
    false,
    false,
    null,
    false,
    params
  )

  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}
